var productLabel = {
  version: "2.5",
  api_url: "",
  label_cache: "",
  current_page: "index",
  product_id: "index",
  cache_time: "none",
  product_media_class: "",
  product_list_tilte_class: "",
  product_list_item_class: "",
  product_container_class: "",
  product_title_class: "",
  plan: "free",
  number_product_lable: 0,
  getLabelItems: async function () {
    const self = this;
    let cacheTime = self.cache_time;
    let txtLabelCache = localStorage.getItem("huk_label_cache");
    let labelCache = txtLabelCache !== null ? JSON.parse(txtLabelCache) : null;
    if (
      labelCache !== null &&
      labelCache?.cache_time &&
      labelCache.cache_time === cacheTime
    ) {
      self.plan = labelCache.plan;
      if (labelCache?.items && labelCache.items.length > 0) {
        if (self.current_page === "product") {
          self.showProductLabel(labelCache.items, labelCache.products);
          setTimeout(function () {
            self.showLabelItems(labelCache.items, labelCache.products);
          }, 1000);
        } else {
          self.showLabelItems(labelCache.items, labelCache.products);
        }
      }
      return false;
    }
    const apiPath = `${self.api_url}?shop=${Shopify.shop}`;
    const response = await self.getAsncRequest(apiPath, "GET", {}, "json");
    let labelItems = [];
    let productPrices = [];
    if (response?.items && response.items.length > 0) {
      labelItems = response.items;
      self.plan = response.plan;
      productPrices = response.products;
      if (self.current_page === "product") {
        self.showProductLabel(response.items, productPrices);
        setTimeout(function () {
          self.showLabelItems(response.items, productPrices);
        }, 1000);
      } else {
        self.showLabelItems(response.items, productPrices);
      }
    }
    let newCache = {
      items: labelItems,
      cache_time: cacheTime,
      products: productPrices,
      plan: response.plan,
    };
    localStorage.setItem("huk_label_cache", JSON.stringify(newCache));
  },
  showLabelItems: function (labelItems, productPrices) {
    // console.log("show label item ", labelItems);
    const self = this;
    const date = new Date();
    let dateString = date.toISOString();
    let dateSplit = dateString.split("T");
    dateString = dateSplit[0];
    let isLogin = document.getElementById("txt-huk-label-cusotmer-id") !== null;
    const currentDate = new Date(dateString);
    const titlClass = self.product_list_tilte_class;
    const itemClass = self.product_list_item_class;
    let productTitleElements = document.querySelectorAll(`.${titlClass}`);
    if (productTitleElements && productTitleElements.length > 0) {
      productTitleElements.forEach((productTitleElement) => {
        let elementId = productTitleElement.getAttribute("id");
        if (!elementId) {
          return true;
        }
        let parentImage = null;
        const parentGridItem = productTitleElement.closest(`.${itemClass}`);
        if (parentGridItem) {
          const imgElement = parentGridItem.querySelector("img");
          if (imgElement) {
            parentImage = imgElement.parentNode.parentNode;
          }
        }
        if (parentImage === null) {
          return true;
        }
        let splitElements = elementId.split("-");
        let productId = splitElements[splitElements.length - 1];
        if (productId && !isNaN(productId)) {
        } else {
          return true;
        }
        let productLabels = labelItems.filter(
          (item) => item.product_id === productId
        );
        if (productLabels && productLabels.length > 0) {
        } else {
          return true;
        }
        let filterLabels = [];
        for (let productLabel of productLabels) {
          // check with date
          let fromDate = productLabel.from_date || "";
          let toDate = productLabel.to_date || "";
          if (fromDate !== "") {
            if (currentDate < new Date(fromDate)) {
              continue;
            }
          }
          if (toDate !== "") {
            if (currentDate > new Date(toDate)) {
              continue;
            }
          }
          if (productLabel.customer === "login") {
            if (!isLogin) {
              continue;
            }
          }
          let showPages = productLabel.show_pages || [];
          if (
            showPages.includes("all") ||
            showPages.includes(self.current_page)
          ) {
            // self.showLabel(parentImage, productLabel, "list");
            filterLabels.push(productLabel);
          }
        }
        if (filterLabels.length > 0) {
          let availableLabels = filterLabels; //self.getLabelByPriority(filterLabels);
          for (let availableLabel of availableLabels) {
            if (availableLabel.is_text === "enable") {
              let product = productPrices.find(
                (item) => item.id === availableLabel.product_id
              );
              let variable = availableLabel.text_variable;
              let variableValue = self.convertVariableToValue(
                variable,
                product
              );
              availableLabel = {
                ...availableLabel,
                label_text: availableLabel.label_text.replace(
                  variable,
                  variableValue
                ),
              };
              if (availableLabel.label_text.trim() === "") {
                continue;
              }
            }
            self.showLabel(parentImage, availableLabel, "list");
          }
        }
      });
    }
  },
  showProductLabel: function (labelItems, productPrices) {
    const self = this;
    const mediaClass = self.product_media_class;
    const productMediaElement = document.querySelector(`.${mediaClass}`);
    if (productMediaElement) {
      let productLabels = labelItems.filter(
        (item) => item.product_id === self.product_id
      );
      let filterLabels = [];
      for (let productLabel of productLabels) {
        let showPages = productLabel.show_pages || [];
        if (
          showPages.includes("all") ||
          showPages.includes(self.current_page)
        ) {
          // self.showLabel(productMediaElement, productLabel, "product");
          filterLabels.push(productLabel);
        }
      }
      if (filterLabels.length > 0) {
        console.log("List label", filterLabels);
      //  let availableLabels = self.getLabelByPriority(filterLabels);
        let availableLabels = filterLabels;
        
        for (let availableLabel of availableLabels) {
          if (availableLabel.is_text === "enable") {
            let product = productPrices.find(
              (item) => item.id === availableLabel.product_id
            );
            let variable = availableLabel.text_variable;
            let variableValue = self.convertVariableToValue(variable, product);
            availableLabel = {
              ...availableLabel,
              label_text: availableLabel.label_text.replace(
                variable,
                variableValue
              ),
            };
            if (availableLabel.label_text.trim() === "") {
              continue;
            }
          }
          self.showLabel(productMediaElement, availableLabel, "product");
        }
      }
    }
  },
  showLabel: function (parentImage, item, type) {
    const self = this;
    let labelClass = `product-label-image`;
    if (type === "list") {
      labelClass = `list-label-image`;
    }
    if (item.animation === "hi_thiere") {
      labelClass += ` huk-animi-wave-image`;
    } else {
      labelClass += ` huk-animi-${item.animation}-image`;
    }
    let imageSrc = item.image_url;
    let previewWidth = parentImage.clientWidth;
    let previewHeight = parentImage.clientHeight;
    let labelStyle = self.getLabelStyle(item, previewWidth, previewHeight);
    let tmpTop = 0;
    let currentProductLabels = parentImage.querySelectorAll('.product-label-image');
    if (type === "list") {
      currentProductLabels = parentImage.querySelectorAll('.list-label-image');
    }
    if(currentProductLabels && currentProductLabels.length > 0) {
      currentProductLabels.forEach(currentProductLabel => {
        tmpTop += currentProductLabel.clientHeight;
      })
    }
    if(tmpTop > 0) {
      labelStyle = {
        ...labelStyle,
        top: `${tmpTop}px`
      }
    }
    
    const imageLabel = self.createLabel(
      `image-${type}-id-${item.product_id}`,
      labelClass,
      item,
      imageSrc,
      labelStyle
    );
    parentImage.appendChild(imageLabel);
  },
  getBadgeItems: async function () {
    const self = this;
    let cacheTime = self.cache_time;
    let txtbadgeCache = localStorage.getItem("huk_badge_cache");
    let badgeCache = txtbadgeCache !== null ? JSON.parse(txtbadgeCache) : null;
    if (
      badgeCache !== null &&
      badgeCache?.cache_time &&
      badgeCache.cache_time === cacheTime
    ) {
      if (badgeCache?.items && badgeCache.items.length > 0) {
        let productBadges = badgeCache.items.filter(
          (item) => item.product_id === self.product_id
        );
        if (productBadges) {
          productBadges.sort((a, b) => a.priority - b.priority);
          for (let productBadge of productBadges) {
            self.showBadge(productBadge);
          }
        }
      }
      return false;
    }
    const apiPath = `${self.api_url}/badges?shop=${Shopify.shop}`;
    const response = await self.getAsncRequest(apiPath, "GET", {}, "json");
    if (response?.items?.length && response.items.length > 0) {
      let productBadges = response.items.filter(
        (item) => item.product_id === self.product_id
      );
      if (productBadges) {
        productBadges.sort((a, b) => a.priority - b.priority);
        for (let productBadge of productBadges) {
          self.showBadge(productBadge);
        }
      }
    }
    let newCache = {
      items: response?.items?.length ? response.items : [],
      cache_time: cacheTime,
    };
    localStorage.setItem("huk_badge_cache", JSON.stringify(newCache));
  },
  showBadge: function (badge) {
    const self = this;
    const productContainer = self.product_container_class;
    const productTitleClass = self.product_title_class;
    const section = document.querySelector(`.${productContainer}`);
    const productTitle = section.querySelector(`.${productTitleClass}`);
    let newImage = document.createElement("img");
    newImage.src = badge.image_url;
    newImage.alt = badge.title;
    newImage.title = badge.title;
    newImage.className = "hukify-badge-image";
    productTitle.insertAdjacentElement("afterend", newImage);
  },
  getLabelStyle: function (item, previewWidth, previewHeight) {
    const self = this;
    let mediaType = item.media_type;

    let width = item.width,
      height = item.height,
      position = item.position;
    let previewSize =
      previewWidth < previewHeight ? previewWidth : previewHeight;
    let labelW = (width * previewSize) / 100;
    let labelH = (height * previewSize) / 100;
    let top = 0;
    let left = 0;
    let middleWidth = previewWidth / 2;
    let middleHeight = previewHeight / 2;
    let style = {
      position: "absolute",
      width: `${labelW}px`,
      height: `${labelH}px`,
      borderRadius: item.border_radius > 0 ? `${item.border_radius}px` : 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      rotate: `${item.rotate}deg`
    };
    if (mediaType === "image_background" || mediaType === "background") {
      style = {
        ...style,
        backgroundColor: item.background_color,
      };
    } else if (mediaType === "image_gradient" || mediaType === "gradient") {
      style = {
        ...style,
        backgroundImage: `linear-gradient(to right, ${item.gradient_start}, ${item.gradient_end})`,
      };
    }
    if (position === "top_center") {
      left = middleWidth - labelW / 2;
      style = {
        ...style,
        top: 0,
        left: `${left}px`,
      };
    } else if (position === "top_right") {
      left = previewWidth - labelW;
      style = {
        ...style,
        top: 0,
        left: `${left}px`,
      };
    } else if (position === "middle_left") {
      top = middleHeight - labelH / 2;
      style = {
        ...style,
        top: `${top}px`,
        left: 0,
      };
    } else if (position === "middle_center") {
      top = middleHeight - labelH / 2;
      left = middleWidth - labelW / 2;
      style = {
        ...style,
        top: `${top}px`,
        left: `${left}px`,
      };
    } else if (position === "middle_right") {
      top = middleHeight - labelH / 2;
      left = previewWidth - labelW;
      style = {
        ...style,
        top: `${top}px`,
        left: `${left}px`,
      };
    } else if (position === "button_left") {
      style = {
        ...style,
        left: 0,
        bottom: 0,
      };
    } else if (position === "button_center") {
      left = middleWidth - labelW / 2;
      style = {
        ...style,
        left: `${left}px`,
        bottom: 0,
      };
    } else if (position === "button_right") {
      left = previewWidth - labelW;
      style = {
        ...style,
        left: `${left}px`,
        bottom: 0,
      };
    } else {
      style = {
        ...style,
        top: 0,
        left: 0,
      };
    }
    return style;
  },
  createLabel: function (id, className, item, src, objectStyle) {
    const self = this;
    // console.log("Label item", item);
    const divElement = document.createElement("div");
    divElement.className = className;
    divElement.id = id;
    Object.keys(objectStyle).forEach((style) => {
      divElement.style[style] = objectStyle[style];
    });
    let animation = item.animation || "none";
    let mediaType = item.media_type || "";
    let newImage = document.createElement("img");
    // const textElement = document.createElement('span');
    if (mediaType !== "" && mediaType.indexOf("image") > -1) {
      newImage.src = src;
      newImage.alt = item.title;
      newImage.title = item.title;
      newImage.style.width = "100%";
      newImage.className = "huk-label-image";
      divElement.appendChild(newImage);
    }
    if (item.is_text === "enable") {
      const pElemet = document.createElement("span");
      pElemet.textContent = item.label_text;
      pElemet.style.color = item.text_color;
      pElemet.style.fontSize = `${item.text_fontsize}px`;
      pElemet.style.fontWeight = item.text_fontweight;
      pElemet.style.fontFamily = item.text_fontfamily;
      pElemet.style.textAlign = "center";
      divElement.appendChild(pElemet);
    }
    return divElement;
  },
  convertVariableToValue: function (variable, product) {
    const self = this;
    let sampleValue = "";
    switch (variable) {
      case "{product_type}":
        sampleValue = product.productType;
        break;
      case "{product_vendor}":
        sampleValue = product.vendor;
        break;
      case "{product_collection}":
        sampleValue = product.collection ? product.collection : "";
        break;
      case "{product_created}":
        let createdAt = product.createdAt.split("T");
        let dateSplit = createdAt[0].split("-");
        sampleValue = `${dateSplit[2]}/${dateSplit[1]}/${dateSplit[0]}`;
        break;
      case "{product_variant}":
        sampleValue = product.variant_total > 0 ? product.variant_total : "";
        break;
      case "{inventory}":
        sampleValue = product.quantity;
        if (self.plan === "free") {
          sampleValue = "";
        }
        break;
      case "{discount_amount}":
        let saleAmount = product.compare_price - product.price;
        sampleValue = saleAmount > 0 ? self.formatPrice(saleAmount) : "";
        if (self.plan === "free") {
          sampleValue = "";
        }
        break;
      case "{discount_percentage}":
        let sale = product.compare_price - product.price;
        let salePercent = (sale * 100) / product.compare_price;
        salePercent = Math.floor(salePercent * 100) / 100;
        // product.compare_price - 100
        // sale - x
        sampleValue = salePercent > 0 ? `${salePercent}%` : "";
        if (self.plan === "free") {
          sampleValue = "";
        }
        break;
      default:
        sampleValue = "";
        break;
    }
    return sampleValue;
  },
  formatPrice: function (num) {
    const self = this;
    const currency = Shopify.currency.active;
    const storeLocal = Shopify.locale;
    const formatter = new Intl.NumberFormat(storeLocal, {
      style: "currency",
      currency: currency,
    });
    return formatter.format(num);
  },
  getLabelByPriority: function (data) {
    const map = new Map();
    data.forEach((item) => {
      const key = `${item.value_id}-${item.position}`;
      if (!map.has(key) || map.get(key).priority < item.priority) {
        map.set(key, item);
      }
    });
    return Array.from(map.values());
  },
  getAsncRequest: function (url, method, data, responseType) {
    let requestOptions = {
      method: method,
      headers: {
        "Content-Type": "application/json",
      },
    };
    if (method === "POST" || method === "PUT") {
      requestOptions = {
        ...requestOptions,
        body: JSON.stringify(data),
      };
    }
    return new Promise((resolve, reject) => {
      fetch(url, requestOptions)
        .then((response) => {
          if (!response.ok) {
            reject(response);
          }
          return responseType === "json" ? response.json() : response.text();
        })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getFonts: async function () {
    const self = this;
    const currentCache =
      localStorage.getItem("huk_label_fonts_cache") !== null
        ? JSON.parse(localStorage.getItem("huk_label_fonts_cache"))
        : null;
    let cacheTime = self.cache_time;
    let fonts = [];
    let okCache = false;
    if (currentCache !== null && currentCache?.cache_time) {
      if (cacheTime === currentCache.cache_time) {
        fonts = currentCache.items;
        okCache = true;
      }
    }
    if (!okCache) {
      const apiPath = `${self.api_url}/fonts?shop=${Shopify.shop}`;
      const response = await self.getAsncRequest(apiPath, "GET", {}, "json");
      if (response && response?.items) {
        fonts = response.items;
      }
      const newCache = {
        items: fonts,
        cache_time: cacheTime,
      };
      localStorage.setItem("huk_label_fonts_cache", JSON.stringify(newCache));
    }
    if (fonts.length > 0) {
      for (let font of fonts) {
        self.addFont(font);
      }
    }
  },
  addFont: function (font) {
    let fontName = font.fontname;
    let fontUrl = font.fontfile;
    const style = document.createElement("style");
    style.innerHTML = `
        @font-face {
            font-family: '${fontName}';
            src: url('${fontUrl}') format('woff2'),
                 url('${fontUrl}') format('woff');
            font-weight: normal;
            font-style: normal;
        }
    `;
    document.head.appendChild(style);
  },
  initData: function () {
    const self = this;
    self.api_url = "/apps/huklabels/labels";
    if (document.getElementById("txt-huk-label-cache") !== null) {
      self.cache_time = document.getElementById("txt-huk-label-cache").value;
    }
    console.log("label version ", self.version);
    self.current_page = document.getElementById("txt-huk-page-type").value;
    if (self.current_page === "product") {
      self.product_id = document.getElementById("txt-huk-product-id").value;
    }
    if (document.getElementById("txt-huk-label-cache") !== null) {
      self.label_cache = document.getElementById("txt-huk-label-cache").value;
    }
    self.product_media_class = document.getElementById(
      "txt-huk-product-media-class"
    ).value;
    self.product_list_tilte_class = document.getElementById(
      "txt-huk-list-title-class"
    ).value;
    self.product_list_item_class = document.getElementById(
      "txt-huk-list-item-class"
    ).value;
    self.product_container_class = document.getElementById(
      "txt-huk-product-container-class"
    ).value;
    self.product_title_class = document.getElementById(
      "txt-huk-product-title-class"
    ).value;
  },
  init: function () {
    const self = this;
    self.initData();
    self.getFonts();
    self.getLabelItems();
    self.getBadgeItems();
    /* self.showBadge(); */
    if (self.current_page === "collection" || self.current_page === "search") {
      let filterConteners = document.getElementById(
        `main-${self.current_page}-filters`
      );
      if(filterConteners !== null) {
        filterConteners.addEventListener("click", function (event) {
        setTimeout(function () {
            self.getLabelItems();
          }, 2000);
        });
        filterConteners.addEventListener("change", function (event) {
          setTimeout(function () {
            self.getLabelItems();
          }, 2000);
        });
      }
      
    }
  },
};
productLabel.init();
